<details
  [class.collapsable]="collapsible()"
  [open]="collapsed() ? undefined : true"
  #detailsRef
>
  <summary
    class="accordion-summary"
    (click)="onToggle($event)"
    (keydown.enter)="onToggle($event)"
    (keydown.space)="onToggle($event)"
  >
    <icon-chevron
      direction="down"
      [class.chevron-open]="!detailsRef.open"
      [class.chevron-closed]="detailsRef.open"
      [size]="32"
    />
    <span>{{ label() }}</span>
    @let headerTemplate = headerTemplateRef();
    @if (headerTemplate) {
      <ng-container [ngTemplateOutlet]="headerTemplate" />
    }
  </summary>
  <div
    class="accordion-content pl-3"
    [class.open]="detailsRef.open"
    [class.closed]="!detailsRef.open"
  >
    <ng-content />
  </div>
</details>
